import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Oppgave } from "../../types/oppgave";

import { TabType } from "../../enums/tabType";

export interface OppgaveListeState {
  aktiveOppgaver: Oppgave[];
  historiskeOppgaver: Oppgave[];
  oppgave?: Oppgave | null | undefined;
  isAktiveLoading: boolean;
  isHistoriskeLoading: boolean;
  hasLoadError: boolean;
  antallHistoriskeOppgaverHentet: number;
  activeTabType: TabType;
}

const initialState: OppgaveListeState = {
  aktiveOppgaver: [],
  historiskeOppgaver: [],
  oppgave: null,
  isAktiveLoading: false,
  isHistoriskeLoading: false,
  hasLoadError: false,
  antallHistoriskeOppgaverHentet: 0,
  activeTabType: TabType.Aktuelle,
};

export const oppgaveListeSlice = createSlice({
  name: "oppgaveListe",
  initialState,
  reducers: {
    setAktiveOppgaver: (state, action: PayloadAction<Oppgave[]>) => {
      state.aktiveOppgaver = action.payload;
    },
    setHistoriskeOppgaver: (state, action: PayloadAction<Oppgave[]>) => {
      state.historiskeOppgaver = action.payload;
      state.antallHistoriskeOppgaverHentet = action.payload.length;
    },
    appendHistoriskeOppgaver: (state, action: PayloadAction<Oppgave[]>) => {
      state.historiskeOppgaver = [
        ...state.historiskeOppgaver,
        ...action.payload,
      ];
      state.antallHistoriskeOppgaverHentet = action.payload.length;
    },
    //Dette er antall historiske oppgaver hentet for hvert kall med PageNumber, ikke totalt antall
    setAntallHistoriskeOppgaverHentet: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.antallHistoriskeOppgaverHentet = action.payload;
    },
    setAktiveLoading: (state, action: PayloadAction<boolean>) => {
      state.isAktiveLoading = action.payload;
    },
    setHistoriskeLoading: (state, action: PayloadAction<boolean>) => {
      state.isHistoriskeLoading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.hasLoadError = action.payload;
    },
    setActiveTabType: (state, action: PayloadAction<TabType>) => {
      state.activeTabType = action.payload;
    },
  },
});

export const {
  setAktiveOppgaver,
  setHistoriskeOppgaver,
  appendHistoriskeOppgaver,
  setAktiveLoading,
  setHistoriskeLoading,
  setError,
  setAntallHistoriskeOppgaverHentet,
  setActiveTabType,
} = oppgaveListeSlice.actions;
export default oppgaveListeSlice.reducer;
